import { AdminApplicationEventsPayload } from "../../types/adminApplicationEvent";
import axiosInstance from "../axios";

export async function getAdminApplicationEvents(since: string, limit = 50): Promise<AdminApplicationEventsPayload> {
  const response = await axiosInstance.get("/admin-application-events", {
    params: {
      since,
      limit
    }
  });

  return response.data.data;
}
